import { render, staticRenderFns } from "./SoftwareParameterDetails.vue?vue&type=template&id=27a73589&scoped=true&"
import script from "./SoftwareParameterDetails.vue?vue&type=script&lang=js&"
export * from "./SoftwareParameterDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareParameterDetails.vue?vue&type=style&index=0&id=27a73589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a73589",
  null
  
)

export default component.exports